import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=4feb7da3&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4feb7da3')) {
      api.createRecord('4feb7da3', component.options)
    } else {
      api.reload('4feb7da3', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=4feb7da3&", function () {
      api.rerender('4feb7da3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ctbu73K6ERw6/JS/comp/openstreetmap.vue"
export default component.exports